var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 18,
    width: 18,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#4318ff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7 4.5a.9.9 0 0 1 .9-.9h10.8a.9.9 0 1 1 0 1.8H3.6a.9.9 0 0 1-.9-.9zM2.7 9a.9.9 0 0 1 .9-.9h10.8a.9.9 0 1 1 0 1.8H3.6a.9.9 0 0 1-.9-.9zM2.7 13.5a.9.9 0 0 1 .9-.9H9a.9.9 0 1 1 0 1.8H3.6a.9.9 0 0 1-.9-.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticle);
export default __webpack_public_path__ + "static/media/article.e5f103c258949b2fef5e9cbca602694e.svg";
export { ForwardRef as ReactComponent };